import styles from "./pet-list.module.css";
import PetFilter from "../Filter";
import List from "./component/List";
import Graph from "./component/Graph";

const PetListView = ({
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  setEditModalOpen,
  setEditData,
  query,
  refreshKey,
}) => {
  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            <PetFilter
              isGridView={isGridView}
              handleView={handleView.bind(this)}
              filterData={filterData}
              setFilterData={setFilterData.bind(this)}
              setAddModalOpen={setAddModalOpen.bind(this)}
            />

            <div className={`${styles.IncomeListingBody}`}>
              <div className={`${styles.IncomeListSec}`}>
                <List
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                  setEditData={setEditData.bind(this)}
                  setEditModalOpen={setEditModalOpen.bind(this)}
                />
              </div>
              <div className={`${styles.IncomeGraphSec}`}>
                <Graph
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetListView;
